import React, { useState, useRef } from "react";
import Modal from "react-modal";
import styled from "styled-components";
import emailjs from "@emailjs/browser";

// Estilos do modal
const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    margin-bottom: 1rem;
  }

  form {
    display: flex;
    flex-direction: column;
    width: 250px;
  }

  label {
    margin-bottom: 0.5rem;
  }

  input,
  textarea {
    padding: 0.5rem;
    margin-bottom: 1rem;
    border: 1px solid #ccc;
    border-radius: 4px;
  }

  button {
    padding: 0.5rem;
    background-color: #007bff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
`;

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginTop: "25px",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px", // Ajuste o tamanho máximo do modal
    padding: "3rem", // Ajuste o padding do modal
  },
};

const ContactFormModal = ({ isOpen, closeModal }) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "gmailMessage",
        "template_79wfxi2",
        form.current,
        "-wZVmAXdUpa7uHT8T"
      )
      .then(
        (result) => {
          alert("Mensagem enviada com sucesso");
          form.current.reset(); // Correctly reset the form fields after sending email
        },
        (error) => {
          alert(error.message);
        }
      );
  };

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  return (
    <>
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        contentLabel="Fale Conosco"
        style={customModalStyles}
      >
        <ModalContent>
          <h2>Fale Conosco</h2>
          <form ref={form} onSubmit={sendEmail}>
            <label htmlFor="name">Nome:</label>
            <input
              type="text"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              name="name"
              autoFocus
            />
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              name="email"
            />
            <label htmlFor="message">Mensagem:</label>
            <textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows="4"
              required
              name="message"
            />
            <button type="submit">Enviar</button>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ContactFormModal;
